import HomeTeasers from './HomeTeasers'

export default HomeTeasers